import { colorsPalettes, mixins, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";
import type { IProModalCustomStyles } from "pro-features/components/Modals/src/ProModal";
import type { FontVariant } from "@similarweb/styles";

const styledText = (fontVariant: FontVariant) => mixins.setFontVariant(fontVariant, colorsPalettes.carbon["400"]);

export const modalStyles: IProModalCustomStyles = {
    content: { padding: "20px 16px 16px 24px", width: 550 },
};

export const StyledTitle = styled.h5`
    ${setFontVariant("h5", colorsPalettes.carbon[500])};

    margin-top: 0;
    margin-bottom: 36px;
`;

export const StyledSubtitle = styled.p`
    ${styledText("body1")};

    margin-bottom: 16px;
`;

export const StyledLegend = styled.p`
    ${styledText("body1")};
`;

export const StyledList = styled.ul`
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    margin: 0 0 24px;
`;

export const StyledDisclaimer = styled.p`
    ${styledText("body2")};

    margin-block-end: 16px;
`;

export const StyledModalFooter = styled.div`
    display: inline-flex;
    width: 100%;
    justify-content: flex-end;
    column-gap: 8px;
`;
